import Model from "./base/model";

class Icms extends Model {
  resourceName() {
    return "icms";
  }

  fields() {
    return {
      origin: "",
      destination: "",
      rate: ""
    };
  }
}
export default new Icms();
